<template>
    <div v-if="!isCustomerAuthenticated" :class="`collapse ${toggleDetailsObject.phone.shown ? 'show' : ''}`"
        data-toggled-by="shippingPhoneNumber">
        <!-- <div>{{'<PhoneInjectPlaceHolder></PhoneInjectPlaceHolder>'}}></div> -->
        <div class="form-group">
            <div v-if="$t('content.asset.CHECKOUT_smsSubscriptionCopy')"
                v-html="$t('content.asset.CHECKOUT_smsSubscriptionCopy')" v-remove-wrapper></div>
        </div>
        <div class="form-group">
            <input type="checkbox" id="sms-subscribe" aria-label="sms-subscribe"
                class="custom-checkbox form-check-input" value="true"
                v-bind="stringAttributesToObjects(lastFormData['shipping'].smsSubscribe.attributes)" />
            <label for="sms-subscribe" class="form-check-label">
                <div v-if="$t('content.asset.CHECKOUT_smsSubscribeLabel')"
                    v-html="$t('content.asset.CHECKOUT_smsSubscribeLabel')" v-remove-wrapper></div>
            </label>
        </div>
    </div>
</template>

<script setup>
import { mapGetters } from "@/store/helper/vuex";
import { reactive, computed } from 'vue'
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";
import { stringAttributesToObjects } from "@/components/helper/util"

const { vueVariables, lastFormData } = mapGetters();

const isCustomerAuthenticated = computed(() => { return vueVariables.value.isCustomerAuthenticated });

const toggleDetailsObject = reactive({
    phone: {
        eventsActive: true,
        shown: false
    }
})

const toggleDetails = (detail) => {
    if (toggleDetailsObject[detail].eventsActive) {
        toggleDetailsObject[detail].shown = true
        toggleDetailsObject[detail].eventsActive = false
    }
}

oldEventBus.$off('shippingFormTogglePhoneDetails');
oldEventBus.$on('shippingFormTogglePhoneDetails', (detail) => {
    toggleDetails(detail)
});

</script>